import {getClientConfig} from 'ultra/configs/general';

import {post, get} from './http';

const {api} = getClientConfig(window)

export function startRaffle(city, did) {
    let link = `${api}/bot/prostir/node/event/${city}/${did}/raffle`;
    return post(link, {});
}

export function getGuestList(city, did) {
    return get(`${api}/bot/prostir/node/event/${city}/${did}/guests`).promise;
}

export function registerGuest(city, did, ticket = 0) {
    return post(`${api}/bot/prostir/node/event/${city}/${did}/tickets/registration/ticket/${ticket}`);
}

export function unregisterGuest(city, did, ticket) {
    return post(`${api}/bot/prostir/node/event/${city}/${did}/tickets/unregistration/ticket/${ticket}`);
}

export function attendGuest(city, did, ticket) {
    return post(`${api}/bot/prostir/node/event/${city}/${did}/tickets/attending/ticket/${ticket}`);
}

export function unattendGuest(city, did, ticket) {
    return post(`${api}/bot/prostir/node/event/${city}/${did}/tickets/unattending/ticket/${ticket}`);
}

export async function removeGuest(city, did, ticket) {
    return post(`${api}/bot/prostir/node/event/${city}/${did}/tickets/removing/ticket/${ticket}`);
}

// export function eventPublishToEvents(city, did) {
//     let link = `${api}/bot/prostir/node/event/${city}/${did}/telegram-publish`
//     return post(link, {});
// }

// export function eventPublishToChats(city, did, chats) {
//     let link = `${api}/bot/prostir/node/event/${city}/${did}/publish/chats`;
//     return post(link, {chats});
// }
